import React from 'react';
import { useDataValue } from 'globals/contexts/dataContext';

import { Link, generatePath } from 'react-router-dom';
import routes from 'globals/routes';

import './landingSection.css';
import './landingSectionMobile.css';

const LandingSection = ({filters, content: pageContent}) => {
  // const  = props['content'];
  const [{content, currentLanguage}, dispatch] = useDataValue();
  const logoUrl = content['logo'];
  return <section className="landing" id="landing">
    <div className="logo">
      <Link to={generatePath(routes.indexPage, {lang: currentLanguage})}>
        <img src={logoUrl} />
      </Link>
    </div>
    <div className="contentWrapper">
      <div className="textContent">
        <div className="header" dangerouslySetInnerHTML={{
          __html: (pageContent['header'])
        }} />
        <div className="quote" dangerouslySetInnerHTML={{
          __html: (pageContent['quote'])
        }} />
        <div className="brief" dangerouslySetInnerHTML={{
          __html: (pageContent['brief'])
        }} />
        <div className="writingStyle">
          <div className="label" dangerouslySetInnerHTML={{
            __html: (pageContent['categorylabel'])
          }} />
          <div className="styleButton">
            <div className="styleIcon">
              <img src={filters[pageContent['type']]['icon']} />
            </div>
            <div className="name">
              <div className="line1">{filters[pageContent['type']]['text']}</div>
              <div className="line2">{filters[pageContent['type']]['text2']}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="imageContent">
        <img src={pageContent['mainImage']} />
      </div>
    </div>
    <div className="decorateLine" />
    <div className="scrollHints" dangerouslySetInnerHTML={{
      __html: pageContent['scrollHints']
    }} />
  </section>;
}

export default LandingSection;